/** This enum will populate all lists regarding number formatting automatically. 'I' = 1 (one), 'O' = 0 (zero),  'd' = '.' (dot), 'c' = ',' (comma), 's' = ' ' (whitespace)  */
export const NUMBER_FORMAT = {
  '10,000.00': 'en-US',
  '10 000,00': 'fr-CA',
  '10.000,00': 'nl-NL'
} as const

export type NumberFormat = (typeof NUMBER_FORMAT)[keyof typeof NUMBER_FORMAT]
